/**
 * Company: SPHMedia
 * Description: [Sticky bar for articles with title, summary and share options also shows reading progress]
 */

import "./styles/stickyBar.css";

import AiSummary from "@blocks/AiSummary/AiSummary";
import ShareSocialButton from "@blocks/ShareSocial/ShareSocialButton";
import { ArticleGaEventsDataProps } from "@elements/ArticleParagraph/ArticleRegwall";
import { ReactElement } from "react";

type ArticleStickyBarProps = {
  title: string;
  progress: number;
  socialIconList: string[];
  pageUrl: string;
  englishHeadline?: string;
  englishSummary?: string;
  tmCustomGaEventsProps?: ArticleGaEventsDataProps;
};

/**
 * ArticleStickyBar
 * Description: [Sticky bar for articles with title, summary and share options also shows reading progress]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function ArticleStickyBar({
  title,
  progress,
  socialIconList,
  pageUrl,
  englishHeadline,
  englishSummary,
  tmCustomGaEventsProps,
}: ArticleStickyBarProps): ReactElement {
  return (
    <div className="v_stickyArticleNow">
      <div className="v_articleRow">
        <div className="v_articleColumn v_titleColumn">
          <div className="v_articleTitle">
            <h3 dangerouslySetInnerHTML={{ __html: title }} />
          </div>
        </div>

        <div className="v_articleColumn v_aiSummarySection">
          {englishHeadline && englishSummary && (
            <AiSummary
              englishHeadline={englishHeadline}
              englishSummary={englishSummary}
              customGaEvents={tmCustomGaEventsProps}
              buttonLabel="SUMMARISE"
            />
          )}
        </div>

        <div className="v_articleColumn v_shareArticle">
          <ShareSocialButton
            socialIconList={socialIconList}
            pagePath={pageUrl}
            mbPopupClassName="absolute right-0"
          />
        </div>
      </div>

      <div className="v_pageMeter">
        <div className="v_pageProgress" style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}
